import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceCircleFilledSvg from "@ant-design/icons-svg/es/asn/BehanceCircleFilled";
import AntdIcon from '../components/AntdIcon';
var BehanceCircleFilled = function BehanceCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BehanceCircleFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BehanceCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BehanceCircleFilled';
}
export default RefIcon;